import api from 'api/instance';
import { FetchQueryType, FetchResponse } from 'types/common';
import { History } from 'types/history';
import { toMidnightISOString } from 'utils/dateUtils';

const URL = `${process.env.REACT_APP_API_URL}`;

export const fetchHistory = async (
  params: FetchQueryType & {
    status?: number[];
    scanId?: string;
    sku?: string[];
    venue?: string[];
    endDate?: Date;
    startDate?: Date;
  },
) => {
  const endDate = toMidnightISOString(params.endDate);
  const startDate = toMidnightISOString(params.startDate);

  const { data } = await api.get<FetchResponse<History>>(
    `${URL}/item/transactions/list`,
    {
      params: {
        ...params,
        startDate,
        endDate,
      },
    },
  );

  return data;
};

export const fetchPackagesHistory = async (
  params: FetchQueryType & {
    status?: number[];
    sku?: string[];
    venue?: string[];
    endDate?: Date;
    startDate?: Date;
  },
) => {
  const endDate = toMidnightISOString(params.endDate);
  const startDate = toMidnightISOString(params.startDate);

  const { data } = await api.get(`${URL}/package/transactions/list`, {
    params: {
      ...params,
      startDate,
      endDate,
    },
  });

  return data;
};

export const fetchCaseHistory = async (
  params: FetchQueryType & {
    status?: number[];
    scanId?: string;
    sku?: string[];
    venue?: string[];
    endDate?: Date;
    startDate?: Date;
  },
) => {
  const endDate = toMidnightISOString(params.endDate);
  const startDate = toMidnightISOString(params.startDate);

  const { data } = await api.get<FetchResponse<History>>(
    `${URL}/case/transactions/list`,
    {
      params: {
        ...params,
        startDate,
        endDate,
      },
    },
  );

  return data;
};
